import { SigatRaw, Sigat } from "./types/sigat";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchSigat(lang: Locale): Promise<Sigat[]> {
  const res = await fetchWithRetry<{ data: SigatRaw[] }>(`/sigat?lang=${cmsLang(lang)}`);

  return res.data.map((item): Sigat => ({
    id: item.id,
    titulo: item.titulo,
    descripcion: item.descripcion,
    contenido: item.contenido,
    imagenes: item.imagenes ?? [],
  }));
}
